<template>
  <div>
    <TopBar
      :title="title"
      @toggleDrawer="$emit('toggleDrawer')"
      :isLoading="isLoading"
    />
    <v-main v-if="queue != null && worker != null">
      <OCol of-hidden class="children-ma-4">
        <OCapCont label="Módulo">
          <router-link :to="`/orgs/${queue.orgCode}`" v-html="queue.orgCode" />
          ::
          <router-link
            v-if="isClientId"
            :to="`/clients/${queue.clientId}`"
            v-html="queue.clientId"
          />
          <span v-else>{{ queue.clientId }}</span>
          ::
          {{ queue.vehicleCode || '(s/placa)' }}
        </OCapCont>

        <OCapCont label="Active/Waiting">
          {{ queue.active || 0 }} ─ {{ queue.waiting || 0 }}
        </OCapCont>

        <OCapCont label="Estado">
          <v-chip small dark label text-color="white" :color="workerLabelClass">
            {{ worker.state || 'missing' }}
          </v-chip>

          (há {{ worker.inStateSince | timeago('HH:mm:ss') }})
        </OCapCont>

        <OCapCont label="Iniciado em">
          {{ worker.lastStartedAt | timeAndSince }}
        </OCapCont>

        <OCapCont label="Conectou em">
          {{ worker.lastConnectedAt | timeAndSince }}
        </OCapCont>

        <OCapCont label="Diagnosticado em">
          {{ worker.diagnosedAt | timeAndSince }}
        </OCapCont>

        <OCapCont label="Último erro em">
          {{ worker.lastWorkerErrorAt | timeAndSince }}
        </OCapCont>

        <OCapCont label="Último erro" v-if="workerErrorStack != null">
          <pre class="err-details">{{ workerErrorStack }}</pre>
        </OCapCont>

        <div>
          <v-btn large block :to="`/mobile/unpauser/${queue.clientId}`">
            Unpauser
          </v-btn>
        </div>
      </OCol>
    </v-main>
  </div>
</template>

<script>
import TopBar from './TopBar.vue'
import _ from 'lodash'
import moment from 'moment'
import { Queue, PipeDiags } from '@/models'
import { timeago } from 'oderon-commons/src/formatters'

export default {
  components: { TopBar },
  props: {
    qname: {}
  },
  data() {
    return {
      isLoading: false,
      queue: null,
      worker: null
    }
  },
  computed: {
    title() {
      let r = this.qname
      if (this.queue != null && this.queue.vehicleCode != null) {
        r = `${this.qname} — ${this.queue.vehicleCode}`
      }
      return r
    },

    isClientId() {
      return (
        this.queue &&
        this.queue.clientId &&
        this.queue.clientId.toString().match(/^\d+$/)
      )
    },

    workerErrorStack() {
      let stack = _.get(this, 'worker.lastWorkerErrorStack')
      if (stack != null) return stack

      let err = _.get(this, 'worker.lastWorkerError')
      if (err == null) return null

      let result = err.stack
      if (err.cause && err.cause.stack != err.stack)
        result += '\ncause: ' + err.cause.stack

      return result
    },

    workerLabelClass() {
      let state = _.get(this, 'worker.state')
      if (state == null) return 'grey'
      if (state == 'active') return 'info'
      if (state == 'waiting') return 'success'
      return 'error'
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },
    async fetchData() {
      // await this.$delay(2000)
      let qname = this.qname

      this.queue = await Queue.findById(qname)

      // Se queue.worker não está null, é o formato
      // novo (qman/Consumer2). Caso esteja null, pode
      // ser buscado no PipeDiags, EXCETO se for uma
      // fila como org/commands, tapman, etc.
      if (this.queue.worker != null) {
        this.worker = this.queue.worker
      } else if (qname.match(/[-\w]+\/\d+$/)) {
        this.worker = await PipeDiags.findById(qname)
      } else {
        this.worker = {}
      }
    }
  },
  filters: {
    timeAndSince(x) {
      if (x == null) return '-'
      let m = moment(x).format(),
        a = timeago(x)
      return `${m} (há ${a})`
    }
  }
}
</script>

<style lang="sass">
.err-details
  overflow-x: auto
  overflow-y: hidden
  font-size: 12pt
</style>
